'use strict';/* global define:false, console */define('modules/core/modules/utils/directives/lock-scrolling',['require'],function(require){'use strict';function directive(){return{restrict:'A',link:function link(scope,element){element.on('mousewheel',function(ev){ev.preventDefault();element[0].scrollTop-=ev.wheelDelta;});}};}// directive.$inject = [
//
// ];
return directive;});
